import gql from 'graphql-tag';

const GET_SEQUENCE_GENERATORS = gql`
  query {
    getSequenceGenerators {
      name
      value
    }
  }
`;

export { GET_SEQUENCE_GENERATORS };
